<div class="col-lg-6 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h80 w-100">
    <div class="w-100 p-4 p-md-5 card border-0" style="max-width: 48rem; padding-top: 0px !important; padding-bottom: 0px !important;">
        <!-- Form -->
        <form class="row g-1 p-0 p-md-4">
            <div class="col-12 text-center mb-5">
                <img src="assets/images/my-page/onboarding/Onboarding-amico.svg" class="w240 mb-4" alt="" />
                <h1>Onboarding</h1>
                <span>Ingrese el RUT y la clave SII para dar de alta su empresa.</span>
            </div>
            <div class="col-12">
                <div class="mb-2">
                    <label class="form-label">RUT</label>
                    <input [formControl]="rutControl" [ngClass]="{'is-invalid': !rutControl.valid && rutControl.touched}" maxlength="30" type="text" class="form-control form-control-lg" placeholder="" (keyup)="rutValidate($event)">
                </div>
                <p *ngIf="!rutControl.valid && rutControl.touched" style="color: red;">Ingrese un RUT válido</p>
            </div>
            <div class="col-12">
                <div class="mb-2">
                    <label class="form-label">Clave SII</label>
                    <input [formControl]="siiControl" [ngClass]="{'is-invalid': !siiControl.valid && siiControl.touched}" maxlength="30" type="text" class="form-control form-control-lg" placeholder="" name="sii">
                </div>
                <p *ngIf="!siiControl.valid && siiControl.touched" style="color: red;">Ingrese una clave SII</p>
            </div>
            <p (click)="seeTerms()" class="terminos-de-uso mt-3"> <i class="fa fa-file-text-o" aria-hidden="true"></i> Terminos de uso</p>
            <div *ngIf="!isLoading" class="col-12 text-center mt-4">
                <a (click)="onEnviar()" [ngClass]="{'disabled': !onboardingForm.valid }" title="" class="btn btn-lg btn-block btn-primary lift text-uppercase">Enviar</a>
            </div>
            <app-loader-w-message *ngIf="isLoading"></app-loader-w-message>
        </form>
        <!-- End Form -->
    </div>
</div>

